export default {
	'shopping-online': {
		id: 'shopping-online',
		label: '线上商城',
		code: '0009',
		child: {}
	}
}
